"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationEntry2ToJSON = exports.NavigationEntry2FromJSONTyped = exports.NavigationEntry2FromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NavigationEntry2FromJSON(json) {
    return NavigationEntry2FromJSONTyped(json, false);
}
exports.NavigationEntry2FromJSON = NavigationEntry2FromJSON;
function NavigationEntry2FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'displayName': json['displayName'],
        'url': json['url'],
        'subEntries': !(0, runtime_1.exists)(json, 'subEntries') ? undefined : (json['subEntries'].map(_1.NavigationEntry3FromJSON)),
    };
}
exports.NavigationEntry2FromJSONTyped = NavigationEntry2FromJSONTyped;
function NavigationEntry2ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'displayName': value.displayName,
        'url': value.url,
        'subEntries': value.subEntries === undefined ? undefined : (value.subEntries.map(_1.NavigationEntry3ToJSON)),
    };
}
exports.NavigationEntry2ToJSON = NavigationEntry2ToJSON;
//# sourceMappingURL=NavigationEntry2.js.map